// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"cdd94109","95":"470521c0","263":"6c7c818b","295":"631f8f32","407":"29d12aa0","429":"06c8bf77","483":"87717822","521":"be035dff","595":"d9c6e68c","608":"ee103967","728":"bb65f549","751":"a31c1707","870":"3d198ed0","988":"9bb16e23","999":"c22e81de"}[chunkId] + ".chunk.js";
};